import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as BeaconService from "_services/beacons-service";
import { getToken } from '_services/user-service';

// initial state of slice
const initialState = {
    beaconList: [],
    wifiLocations: {}, // { [devEui]: { resolvedAt, located, lat, lng, confidence, floorLabel } }
    loading: false,
    error: null,
};

export const getBeaconList = createAsyncThunk(
    "beacons/getBeaconList",
    async (params) => {
        return BeaconService.getBeaconList(params);
    }
);

export const resolveWifiLocation = createAsyncThunk(
    "assetTracking/resolveWifiLocation",
    async ({ devEui, iata, scans, resolvedAt }) => {
        const token = await getToken();
        const res = await fetch(`/api/v1/mobileusers/wifi-survey/locate/${iata}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Firebase-UID': token },
            body: JSON.stringify({ scans }),
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();
        return { devEui, resolvedAt, ...data };
    }
);

const assetTrackingSlice = createSlice({
    name: "assetTracking",
    initialState,
    reducers: {
        reset: (state) => {
            state.beaconList = [];
            state.loading = false;
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getBeaconList.pending, (state) => {
                state.beaconList = [];
                state.loading = true;
                state.error = null;
            })
            .addCase(getBeaconList.fulfilled, (state, action) => {
                state.beaconList = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(getBeaconList.rejected, (state, action) => {
                console.error("Failed to fetch UUID and coordinates:", action.error);
                state.beaconList = [];
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(resolveWifiLocation.fulfilled, (state, action) => {
                const { devEui, resolvedAt, located, lat, lng, confidence, floorLabel, locationId, matchedMacs } = action.payload;
                // Drop responses that arrived out of order (older event resolved after newer one)
                if ((state.wifiLocations[devEui]?.resolvedAt ?? 0) > resolvedAt) return;
                state.wifiLocations[devEui] = { resolvedAt, located, lat, lng, confidence, floorLabel, locationId, matchedMacs };
            });
    }
});

export const selectBeaconList = (state) => state.assetTracking.beaconList;
export const selectWifiLocations = (state) => state.assetTracking.wifiLocations;

export const { reset } = assetTrackingSlice.actions;
export default assetTrackingSlice.reducer;